import React from "react";
export default function SVGStructure2() {
  return (
    <svg viewBox="0 0 489.091 489.091">
      <g fill="#000000">
        <path
          fill="#000000"
          opacity="0.2"
          d="M122.346,281.291h243.8v40.9h21.4v-51.7c0-5.9-4.8-10.7-10.7-10.7h-121.9v-39h-21.4v39h-121.9c-5.9,0-10.7,4.8-10.7,10.7
			v50.2h21.4V281.291z"
        />
        <path
          fill="#000000"
          d="M244.346,199.291h86.4c-0.5-35.9,1-55.1-22.3-63.6c-21.2-8.1-33.8-16.3-33.8-16.3l-16.3,51.5l-2.2,7l-7.3-20.7
			c16.8-23.4-1.3-24.5-4.4-24.5l0,0c0,0,0,0-0.1,0l0,0l0,0c0,0,0,0-0.1,0l0,0c-3.1,0-21.2,1.1-4.4,24.5l-7.3,20.7l-2.2-7l-16.3-51.5
			c0,0-12.7,8.3-33.8,16.3c-23.3,8.5-21.9,27.6-22.3,63.6h82.1L244.346,199.291L244.346,199.291z"
        />
        <path
          fill="#000000"
          d="M207.846,86.591c1.9,12.1,11.2,27.5,26.6,32.9c6.3,2.2,13.2,2.2,19.5,0c15.1-5.4,24.8-20.8,26.6-32.9
			c2-0.2,4.7-3,7.6-13.2c3.9-13.9-0.2-16-3.8-15.7c0.7-1.9,1.2-3.8,1.5-5.7c6-36.1-11.8-37.3-11.8-37.3s-2.9-5.7-10.7-9.9
			c-5.2-3.1-12.4-5.5-22-4.6c-3.1,0.1-6,0.7-8.8,1.7l0,0c-3.5,1.2-6.7,2.9-9.6,4.9c-3.6,2.3-6.9,5-9.9,8.2
			c-4.7,4.8-8.9,11-10.7,18.8c-1.5,5.8-1.2,11.8,0.1,18.3l0,0c0.3,1.9,0.8,3.8,1.5,5.7c-3.5-0.3-7.7,1.7-3.8,15.7
			C203.146,83.591,205.846,86.391,207.846,86.591z"
        />
        <path
          fill="#000000"
          opacity="0.5"
          d="M425.146,441.391c-15.9-6.1-25.4-12.3-25.4-12.3l-12.2,38.7l-1.7,5.2l-5.5-15.5c12.6-17.6-1-18.4-3.3-18.4l0,0l0,0l0,0
			l0,0l0,0l0,0c-2.3,0-15.9,0.9-3.3,18.4l-5.5,15.5l-1.7-5.2l-12.2-38.7c0,0-9.5,6.2-25.4,12.3c-17.5,6.3-16.4,20.7-16.7,47.7h61.6
			h3.3h64.8C441.546,462.091,442.646,447.691,425.146,441.391z"
        />
        <path
          fill="#000000"
          opacity="0.7"
          d="M374.946,339.691c-2.3,0.1-4.5,0.6-6.6,1.3l0,0c-2.6,0.9-5,2.2-7.2,3.7c-2.7,1.7-5.2,3.8-7.4,6.1c-3.5,3.6-6.7,8.3-8,14.1
			c-1.1,4.3-0.9,8.9,0.1,13.8l0,0c0.3,1.4,0.6,2.9,1.2,4.3c-2.7-0.3-5.8,1.3-2.8,11.7c2.2,7.6,4.2,9.8,5.7,9.9
			c1.4,9.1,8.4,20.6,19.9,24.7c4.7,1.7,9.9,1.7,14.6,0c11.3-4.1,18.6-15.6,20-24.7c1.5-0.1,3.5-2.3,5.7-9.9c3-10.5-0.2-12-2.8-11.7
			c0.5-1.4,0.9-2.9,1.2-4.3c4.5-27.1-8.8-28-8.8-28s-2.2-4.2-8-7.5C387.546,340.791,382.146,338.991,374.946,339.691z"
        />
        <path
          fill="#000000"
          opacity="0.7"
          d="M160.046,441.391c-15.9-6.1-25.4-12.3-25.4-12.3l-12.2,38.7l-1.7,5.2l-5.5-15.5c12.6-17.6-1-18.4-3.3-18.4l0,0l0,0l0,0
			l0,0l0,0l0,0c-2.3,0-15.9,0.9-3.3,18.4l-5.5,15.5l-1.7-5.2l-12.2-38.7c0,0-9.5,6.2-25.4,12.3c-17.5,6.3-16.4,20.7-16.7,47.7h61.6
			h3.3h64.8C176.446,462.091,177.446,447.691,160.046,441.391z"
        />
        <path
          fill="#000000"
          opacity="0.7"
          d="M84.646,404.591c1.4,9.1,8.4,20.6,19.9,24.7c4.7,1.7,9.9,1.7,14.6,0c11.3-4.1,18.6-15.6,20-24.7c1.5-0.1,3.5-2.3,5.7-9.9
			c3-10.5-0.2-12-2.8-11.7c0.5-1.4,0.9-2.9,1.2-4.3c4.5-27.1-8.8-28-8.8-28s-2.2-4.2-8-7.5c-3.9-2.3-9.3-4.1-16.5-3.5
			c-2.3,0.1-4.5,0.6-6.6,1.3l0,0c-2.6,0.9-5,2.2-7.2,3.7c-2.7,1.7-5.2,3.8-7.4,6.1c-3.5,3.6-6.7,8.3-8,14.1
			c-1.1,4.3-0.9,8.9,0.1,13.8l0,0c0.3,1.4,0.6,2.9,1.2,4.3c-2.7-0.3-5.8,1.3-2.8,11.7C81.046,402.291,83.146,404.391,84.646,404.591
			z"
        />
      </g>
    </svg>
  );
}
